import { Link } from 'react-router-dom';

function KybPrivacyPolicy() {
  return (
    <main className='px-6 py-12'>
      <div className='mx-auto max-w-[800px]'>
        <h1 className='mb-6 pb-4 text-center text-2xl font-bold'>
          紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）{'　'}プライバシーポリシー
        </h1>

        <p className='mb-4'>
          株式会社紀陽銀行（以下「当行」といいます）は、当行が提供する紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）（以下「本サービス」といいます）における、利用者（以下「ユーザー」といいます）の個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
        </p>
        <p className='mb-4'>
          ユーザーの個人情報の取扱いについては、本ポリシーに定めるもののほか、当行ホームページに掲載する個人情報保護宣言その他「お客さま情報の取扱いについて」の各条項が適用されます。
        </p>
        <p className='mb-8'>
          【お客さま情報の取り扱いについて】{' '}
          <Link
            to='https://www.kiyobank.co.jp/contentsprivacy/'
            className='text-primary-500 underline hover:text-primary-700'
            target='_blank'
          >
            https://www.kiyobank.co.jp/contentsprivacy/
          </Link>
        </p>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１条（目的）</h2>
          <p className='mb-4'>
            当行は、「個人情報の保護に関する法律」および関係法令等を遵守し、お客さまの個人情報を適切に取り扱います。また、個人情報は、本サービスの提供および公表している利用目的の達成に必要な範囲で利用し、それ以外の目的では利用いたしません。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第２条（取得する情報の種類および方法）</h2>
          <section className='mb-4'>
            <h3 className='mb-2 text-lg font-semibold'>１. 取得方法</h3>
            <p className='mb-2'>
              当行は、本サービスの提供にあたり、主として以下の方法により情報を取得します。
            </p>
            <ul className='mb-4 list-disc pl-6'>
              <li>ユーザーからＷｅｂ画面、申込フォーム等により直接ご提供いただく方法</li>
              <li>ユーザーが本サービスを利用することに伴い、当行において記録する方法</li>
            </ul>
          </section>
          <section className='mb-4'>
            <h3 className='mb-2 text-lg font-semibold'>２. 取得する情報の種類</h3>
            <p className='mb-2'>当行は、以下の情報を取得します。</p>
            <ul className='mb-4 list-disc pl-6'>
              <li>基本情報：企業名、氏名、住所、メールアドレス、部署名、役職等</li>
              <li>アカウント情報：ユーザーＩＤ、パスワード等</li>
              <li>アクセス情報：ＩＰアドレス、Ｃｏｏｋｉｅ、ブラウザの種類、端末情報等</li>
              <li>利用履歴：閲覧ページ、利用時間帯等</li>
              <li>ＤＸ診断情報：ユーザーが回答した診断結果データ等</li>
              <li>コミュニティ投稿情報：ユーザーが本サービス内のコミュニティで投稿した内容等</li>
              <li>お問い合わせ情報：ユーザーがお問い合わせ時に提供する内容等</li>
            </ul>
          </section>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第３条（利用目的）</h2>
          <p className='mb-2'>当行は、取得した個人情報を以下の目的で利用します。</p>
          <ol className='mb-4 list-decimal pl-6'>
            <li>本サービスの提供・運営</li>
            <li>ＤＸ診断の実施および診断結果の提供</li>
            <li>プラットフォーム運営および適切なモデレーション</li>
            <li>ユーザーへの通知、問い合わせ対応、適切なサービスのレコメンド</li>
            <li>本サービスの改善および新機能の開発</li>
            <li>
              アクセス情報、利用履歴、ＤＸ診断情報等の情報の分析を通じた、ユーザーへの他のサービスの提案等
            </li>
            <li>統計データの作成および分析（個人を特定できない形での活用）</li>
            <li>法令の遵守および不正利用防止</li>
          </ol>
          <p className='mb-4'>
            また、当行は、利用目的達成に必要な範囲内で、個人情報の取扱いを第三者に委託することがあります。この場合、当行は委託先に対し必要かつ適切な監督を行います。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第４条（管理体制）</h2>
          <p className='mb-4'>
            当行は、ユーザーの個人情報を適切に管理し、漏洩、滅失、改ざん等の防止措置を講じます。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第５条（保存期間）</h2>
          <p className='mb-4'>
            当行は、取得した個人情報を、利用目的の達成に必要な期間に限り保管し、その後は関係法令等に基づき適切な方法で削除または匿名化します。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第６条（第三者提供の制限）</h2>
          <p className='mb-2'>
            当行は、以下の場合を除き、お客さまの個人データを第三者に提供しません。
          </p>
          <ul className='mb-4 list-disc pl-6'>
            <li>ユーザーの同意がある場合</li>
            <li>法令に基づく場合</li>
            <li>不正行為の防止および法的権利の保護のために必要な場合</li>
            <li>人の生命、身体または財産の保護のために必要な場合</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第７条（Ｃｏｏｋｉｅ等の利用）</h2>
          <p className='mb-2'>
            本サービスでは、ユーザーの利便性向上やサービス改善および安全性確保のため、Ｃｏｏｋｉｅ、広告識別子ＩＤ、ウェブビーコン等の技術を以下の目的で利用します。当行はこれにより、ウェブサイトの閲覧履歴、利用履歴等の情報を取得することができます。
          </p>
          <ul className='mb-4 list-disc pl-6'>
            <li>ユーザーのログイン状態の保持、本サービスの利便性向上</li>
            <li>本サービスの利用状況の把握および分析（統計的な調査を含む）</li>
            <li>不正アクセス防止やセキュリティ向上</li>
            <li>ユーザーの興味・関心に応じた情報提供</li>
          </ul>
          <p className='mb-4'>
            なお、ユーザーはブラウザ設定を変更することで、Cookie等の受け入れを制御できますが、その場合、本サービスの一部機能が利用できなくなる可能性はあります。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>
            第８条（Ｇｏｏｇｌｅ{'　'}Ａｎａｌｙｔｉｃｓの利用）
          </h2>
          <p className='mb-2'>
            本サービスでは、利用状況の分析およびサービス改善のため、Ｇｏｏｇｌｅ{'　'}Ａｎａｌｙｔｉｃｓを使用しています。Ｃｏｏｋｉｅを利用して訪問データを収集しますが、個人を特定する情報は含まれていません。
          </p>
          <ul className='mb-4 list-none pl-6'>
            <li className='mb-2'>
              ・Ｇｏｏｇｌｅアナリティクス サービス利用規約
              <br />
              <Link
                to='https://marketingplatform.google.com/about/analytics/terms/jp/'
                className='text-primary-500 underline hover:text-primary-700'
                target='_blank'
              >
                https://marketingplatform.google.com/about/analytics/terms/jp/
              </Link>
            </li>
            <li className='mb-2'>
              ・Ｇｏｏｇｌｅのプライバシーポリシー
              <br />
              <Link
                to='https://policies.google.com/privacy?hl=ja'
                className='text-primary-500 underline hover:text-primary-700'
                target='_blank'
              >
                https://policies.google.com/privacy?hl=ja
              </Link>
            </li>
            <li className='mb-2'>
              ・Ｇｏｏｇｌｅアナリティクス オプトアウト アドオン
              <br />
              <Link
                to='https://tools.google.com/dlpage/gaoptout'
                className='text-primary-500 underline hover:text-primary-700'
                target='_blank'
              >
                https://tools.google.com/dlpage/gaoptout
              </Link>
            </li>
          </ul>
          <p className='mb-4'>
            なお、Ｇｏｏｇｌｅ{'　'}Ａｎａｌｙｔｉｃｓの利用による損害について、当行は責任を負いません。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第９条（セキュリティ対策）</h2>
          <p className='mb-2'>
            当行は、個人情報を適切に管理し、不正アクセスや情報漏洩等を防ぐため、以下の措置を講じます。
          </p>
          <ul className='mb-4 list-disc pl-6'>
            <li>暗号化通信の採用（ＳＳＬ／ＴＬＳ）</li>
            <li>アクセス制御および内部監査の実施</li>
            <li>個人情報取扱者への教育、指導</li>
          </ul>
          <p className='mb-4'>また、定期的な点検および監査を実施し、継続的な改善に努めます。</p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１０条（お問い合わせ窓口）</h2>
          <p className='mb-2'>「紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）」事務局</p>
          <ul className='mb-4 list-none'>
            <li>住所：和歌山市本町１丁目３５番地</li>
            <li>
              メールアドレス：
              <a
                href='mailto:keyx@kiyobank.co.jp'
                className='text-primary-500 underline hover:text-primary-700'
              >
                keyx@kiyobank.co.jp
              </a>
            </li>
            <li>受付時間：銀行営業日 ９:００～１７:００</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１１条（本ポリシーの変更）</h2>
          <p className='mb-4'>
            当行は、法令改正やサービス内容の変更等に応じて、本ポリシーを見直し、必要に応じて改定することがあります。
          </p>
          <p className='mb-4'>変更後の内容は、本サービス上への掲載等により公表します。</p>
        </section>

        <p className='mt-8'>以{'　'}上</p>
      </div>
    </main>
  );
}

export default KybPrivacyPolicy;
